import { jsx as i, jsxs as L, Fragment as O } from "react/jsx-runtime";
import * as s from "react";
import { u as w } from "../../index-5Bhkapwi.js";
import { c as H, u as G, a as S } from "../../index-DcwNtM_b.js";
import { u as K } from "../../index-BZPx6jYI.js";
import { u as U } from "../../index-Ck1TnIqh.js";
import { P as X } from "../../index-DBEov9sD.js";
import { P as _ } from "../../index-CpDnqHCm.js";
import { c as $ } from "../../utils-BOFVZgHd.js";
import { C as J } from "../../check-B9pOV8LL.js";
var y = "Checkbox", [Q, de] = H(y), [V, E] = Q(y);
function W(t) {
  const {
    __scopeCheckbox: n,
    checked: r,
    children: l,
    defaultChecked: a,
    disabled: e,
    form: p,
    name: b,
    onCheckedChange: d,
    required: m,
    value: k = "on",
    // @ts-expect-error
    internal_do_not_use_render: u
  } = t, [f, x] = G({
    prop: r,
    defaultProp: a ?? !1,
    onChange: d,
    caller: y
  }), [C, v] = s.useState(null), [g, o] = s.useState(null), c = s.useRef(!1), R = C ? !!p || !!C.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), P = {
    checked: f,
    disabled: e,
    setChecked: x,
    control: C,
    setControl: v,
    name: b,
    form: p,
    value: k,
    hasConsumerStoppedPropagationRef: c,
    required: m,
    defaultChecked: h(a) ? !1 : a,
    isFormControl: R,
    bubbleInput: g,
    setBubbleInput: o
  };
  return /* @__PURE__ */ i(
    V,
    {
      scope: n,
      ...P,
      children: Y(u) ? u(P) : l
    }
  );
}
var B = "CheckboxTrigger", M = s.forwardRef(
  ({ __scopeCheckbox: t, onKeyDown: n, onClick: r, ...l }, a) => {
    const {
      control: e,
      value: p,
      disabled: b,
      checked: d,
      required: m,
      setControl: k,
      setChecked: u,
      hasConsumerStoppedPropagationRef: f,
      isFormControl: x,
      bubbleInput: C
    } = E(B, t), v = w(a, k), g = s.useRef(d);
    return s.useEffect(() => {
      const o = e?.form;
      if (o) {
        const c = () => u(g.current);
        return o.addEventListener("reset", c), () => o.removeEventListener("reset", c);
      }
    }, [e, u]), /* @__PURE__ */ i(
      _.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": h(d) ? "mixed" : d,
        "aria-required": m,
        "data-state": z(d),
        "data-disabled": b ? "" : void 0,
        disabled: b,
        value: p,
        ...l,
        ref: v,
        onKeyDown: S(n, (o) => {
          o.key === "Enter" && o.preventDefault();
        }),
        onClick: S(r, (o) => {
          u((c) => h(c) ? !0 : !c), C && x && (f.current = o.isPropagationStopped(), f.current || o.stopPropagation());
        })
      }
    );
  }
);
M.displayName = B;
var I = s.forwardRef(
  (t, n) => {
    const {
      __scopeCheckbox: r,
      name: l,
      checked: a,
      defaultChecked: e,
      required: p,
      disabled: b,
      value: d,
      onCheckedChange: m,
      form: k,
      ...u
    } = t;
    return /* @__PURE__ */ i(
      W,
      {
        __scopeCheckbox: r,
        checked: a,
        defaultChecked: e,
        disabled: b,
        required: p,
        onCheckedChange: m,
        name: l,
        form: k,
        value: d,
        internal_do_not_use_render: ({ isFormControl: f }) => /* @__PURE__ */ L(O, { children: [
          /* @__PURE__ */ i(
            M,
            {
              ...u,
              ref: n,
              __scopeCheckbox: r
            }
          ),
          f && /* @__PURE__ */ i(
            j,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }
);
I.displayName = y;
var T = "CheckboxIndicator", q = s.forwardRef(
  (t, n) => {
    const { __scopeCheckbox: r, forceMount: l, ...a } = t, e = E(T, r);
    return /* @__PURE__ */ i(
      X,
      {
        present: l || h(e.checked) || e.checked === !0,
        children: /* @__PURE__ */ i(
          _.span,
          {
            "data-state": z(e.checked),
            "data-disabled": e.disabled ? "" : void 0,
            ...a,
            ref: n,
            style: { pointerEvents: "none", ...t.style }
          }
        )
      }
    );
  }
);
q.displayName = T;
var A = "CheckboxBubbleInput", j = s.forwardRef(
  ({ __scopeCheckbox: t, ...n }, r) => {
    const {
      control: l,
      hasConsumerStoppedPropagationRef: a,
      checked: e,
      defaultChecked: p,
      required: b,
      disabled: d,
      name: m,
      value: k,
      form: u,
      bubbleInput: f,
      setBubbleInput: x
    } = E(A, t), C = w(r, x), v = K(e), g = U(l);
    s.useEffect(() => {
      const c = f;
      if (!c) return;
      const R = window.HTMLInputElement.prototype, N = Object.getOwnPropertyDescriptor(
        R,
        "checked"
      ).set, D = !a.current;
      if (v !== e && N) {
        const F = new Event("click", { bubbles: D });
        c.indeterminate = h(e), N.call(c, h(e) ? !1 : e), c.dispatchEvent(F);
      }
    }, [f, v, e, a]);
    const o = s.useRef(h(e) ? !1 : e);
    return /* @__PURE__ */ i(
      _.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: p ?? o.current,
        required: b,
        disabled: d,
        name: m,
        value: k,
        form: u,
        ...n,
        tabIndex: -1,
        ref: C,
        style: {
          ...n.style,
          ...g,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
j.displayName = A;
function Y(t) {
  return typeof t == "function";
}
function h(t) {
  return t === "indeterminate";
}
function z(t) {
  return h(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
const Z = s.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ i(
  I,
  {
    ref: r,
    "data-slot": "checkbox",
    className: $(
      "peer size-4 shrink-0 rounded-sm border border-[var(--border)]",
      "bg-[var(--background)] transition-colors duration-200",
      "data-[state=checked]:border-[var(--primary)] data-[state=checked]:bg-[var(--primary)] data-[state=checked]:text-[var(--primary-foreground)]",
      "focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-0",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "aria-invalid:border-[var(--destructive)] aria-invalid:ring-[var(--destructive)]/20",
      "dark:aria-invalid:ring-[var(--destructive)]/40",
      t
    ),
    ...n,
    children: /* @__PURE__ */ i(
      q,
      {
        "data-slot": "checkbox-indicator",
        className: "flex items-center justify-center text-current",
        children: /* @__PURE__ */ i(J, { className: "size-3.5" })
      }
    )
  }
));
Z.displayName = I.displayName;
export {
  Z as Checkbox
};
//# sourceMappingURL=checkbox.js.map
